// Derive a deterministic fake star rating between 3.5 and 4.0 (in 0.5 steps)
// from a designer ID. Stable across builds for the same designer so the
// homepage doesn't reshuffle ratings on every revalidate.
export default function fakeRating(designerId: string): number {
  let hash = 0;
  for (let i = 0; i < designerId.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    hash = (hash * 31 + designerId.charCodeAt(i)) | 0;
  }
  // 0 or 1 → 3.5 or 4.0
  const bucket = Math.abs(hash) % 2;
  return 3.5 + bucket * 0.5;
}
